import React from 'react'
import { useNavigate } from 'react-router-dom'

import './introPage.scss'

const IntroPage = () => {
    const navigate = useNavigate()
    return (
        <div id="intro-total">
            <h1>Välkommen till en prototyp för kundhändelsetypskatalogen</h1>
            <div className="container-fluid">
                <div className="row introtext">Byggblocket Mina ärenden har tagit fram denna prototyp för att testa och visualisera hur en kundhändelsetypskatalog skulle kunna utformas samt vilken information och funktionalitet som bör tillhandahållas. Vi hoppas på så sätt kunna få bättre förståelse för hur en framtida kundhändelsetypskatalog bör utformas för att möta upp de krav och behov som finns.</div>
                <div className="row introtext">All information i prototypen är påhittad och avser endast ge exempel på hur det skulle kunna se ut i en verklig kundhändelsetypskatalog.</div>
                <div className="row justify-content-evenly">
                    <div className="col">
                        <button className="col introbutton" onClick={() => {navigate('/search')}}>Till prototypen kundhändelsetypskatalogen</button>
                    </div>
                    <div className="col">
                        <button className="introbutton" onClick={() => {window.location.href = 'https://community.dataportal.se/topic/658/prototyp-kundh%C3%A4ndelsetypskatalog'}}>Läs mer om kundhändelsetypskatalogen</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IntroPage